<template>
  <div class="stepper">
    <button
      class="stepper__button"
      :disabled="disableDecrement"
      @click="decreaseCount"
    >
      <span class="stepper__number">-</span>
    </button>
    <span class="count">{{ count }}</span>
    <button
      class="stepper__button"
      :disabled="disableIncrement"
      @click="increaseCount"
    >
      <span>+</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "NumberStepper",
  props: {
    count: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: null,
    },
  },
  emits: ["change"],
  computed: {
    disableIncrement() {
      if (this.max) {
        return !(this.max && this.count < this.max);
      }
      return false;
    },
    disableDecrement() {
      return !(this.count > 1);
    },
  },
  methods: {
    decreaseCount() {
      if (!this.disableDecrement) {
        this.$emit("change", this.count - 1);
      }
    },
    increaseCount() {
      if (!this.disableIncrement) {
        this.$emit("change", this.count + 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stepper {
  display: flex;
  align-items: center;

  &__button {
    height: 15px;
    width: 15px;
    text-align: center;
    border-radius: 100%;
    background: $color-light;
    outline: none;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &:first-child {
      margin-right: 10px;
    }
    &:last-child {
      margin-left: 10px;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.2;
    }
  }
}
</style>
